module.exports = __webpack_public_path__ + "img/login-bg@2x.a1b3117f.png";